import { isEqual as _isEqual } from 'lodash-es';

export function isEqual<T, U = T>(a: T, b: U): boolean {
	return _isEqual(a, b);
}
